// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_fvN","name":"styles_name__qW3TD","phone":"styles_phone__v4Hju"};